import { render, staticRenderFns } from "./AgxMediaList.vue?vue&type=template&id=997f9fb8&scoped=true&"
import script from "./AgxMediaList.vue?vue&type=script&lang=js&"
export * from "./AgxMediaList.vue?vue&type=script&lang=js&"
import style0 from "./AgxMediaList.vue?vue&type=style&index=0&id=997f9fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997f9fb8",
  null
  
)

export default component.exports